// extracted by mini-css-extract-plugin
export default {"statusContainer":"DeviceStatus_statusContainer__vSV80","left":"DeviceStatus_left__zqCZ1","dialog":"DeviceStatus_dialog__ONl8K"};